import React, { useState } from 'react';
import { useUI, useActions } from '../../context/AppContext';
import TwoStepConfirmModal from '../ui/TwoStepConfirmModal';
import { deleteStudentPermanently } from '../../services/students';

const OgrenciCikarModal = ({ isOpen, onClose, ogrenci, loggedInUser, showToast }) => {
  const { goToInstructorTab, setSelectedStudent } = useUI();
  const { sendNotification } = useActions();
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemove = async () => {
    if (isRemoving) return;
    setIsRemoving(true);
    try {
      await deleteStudentPermanently(ogrenci.id);
      await sendNotification(
        loggedInUser.emailOrPhone,
        `${ogrenci.name} silindi; ödeme kayıtları arşivde.`
      ).catch(() => {});
      showToast(`${ogrenci.name} silindi.`);
      setSelectedStudent?.(null);
      goToInstructorTab('students');
      onClose();
    } catch (err) {
      const code = String(err?.code || '').replace(/^functions\//, '');
      const known = ['not-found', 'permission-denied', 'invalid-argument'].includes(code);
      showToast(known && err?.message ? err.message : 'Öğrenci silinemedi. Lütfen tekrar deneyin.', 'error');
      throw err;
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <TwoStepConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleRemove}
      title="Öğrenciyi Sil"
      step1Description={`${ogrenci?.name || 'Öğrenci'} ve verileri (programlar, dereceler, giriş hesabı) kalıcı olarak silinecek. Ödeme kayıtları Ödeme Arşivi'nde "Ayrılan öğrenciler" altında kalır; oradan ayrıca silebilirsiniz. Öğrenci isterse aynı bilgilerle yeniden kayıt olabilir.`}
      step2Description="Son onay: bu işlem geri alınamaz."
      confirmLabel="Evet, Sil"
      tone="danger"
      busy={isRemoving}
      busyLabel="Siliniyor..."
    />
  );
};

export default OgrenciCikarModal;
